export default __webpack_public_path__ + "static/media/step2_shake.37d67642.png";